// ツムラ漢方名 → KampoDB Formula ID のマッピング（全127種）
// KampoDBのFormula IDはローマ字の略称（例: KT = Kakkonto）
export const tsumuraNameToKampoDBId = {
  "葛根湯": "KT",
  "葛根湯加川芎辛夷": "KTSS",
  "乙字湯": "OJT",
  "安中散": "ACS",
  "十味敗毒湯": "JHT",
  "八味地黄丸": "HJG",
  "大柴胡湯": "DST",
  "小柴胡湯": "SSK",
  "柴胡桂枝湯": "SAKT",
  "柴胡桂枝乾姜湯": "SAKK",
  "柴胡加竜骨牡蛎湯": "SRB",
  "半夏瀉心湯": "HST",
  "黄連解毒湯": "OGT",
  "半夏厚朴湯": "HKT",
  "五苓散": "GRS",
  "桂枝加朮附湯": "KSTJB",
  "小青竜湯": "SST",
  "防已黄耆湯": "BOT",
  "小半夏加茯苓湯": "SHB",
  "消風散": "SFS",
  "当帰芍薬散": "TSS",
  "加味逍遙散": "KSS",
  "桂枝茯苓丸": "KBG",
  "桂枝加竜骨牡蛎湯": "KSTRB",
  "麻黄湯": "MT",
  "越婢加朮湯": "EPTJ",
  "麦門冬湯": "BAK",
  "真武湯": "SIT",
  "呉茱萸湯": "GSY",
  "人参湯": "NT",
  "大黄牡丹皮湯": "DBT",
  "白虎加人参湯": "BKTN",
  "四逆散": "SGS",
  "木防已湯": "MBT",
  "半夏白朮天麻湯": "HBT",
  "当帰四逆加呉茱萸生姜湯": "TSGST",
  "苓桂朮甘湯": "RKJK",
  "猪苓湯": "CRT",
  "補中益気湯": "HET",
  "六君子湯": "RKT",
  "桂枝湯": "KST",
  "七物降下湯": "SCMKT",
  "釣藤散": "CTS",
  "十全大補湯": "JTT",
  "荊芥連翹湯": "KRT",
  "潤腸湯": "JCT",
  "薏苡仁湯": "YT",
  "疎経活血湯": "SOKT",
  "抑肝散": "YKS",
  "麻杏甘石湯": "MKKS",
  "五淋散": "GS",
  "温清飲": "USI",
  "清上防風湯": "SJBT",
  "治頭瘡一方": "JZI",
  "桂枝加芍薬湯": "KSTS",
  "桃核承気湯": "TJT",
  "防風通聖散": "BTS",
  "五積散": "GSS",
  "炙甘草湯": "SKZT",
  "帰脾湯": "KIT",
  "参蘇飲": "JSI",
  "女神散": "NSS",
  "芍薬甘草湯": "SKT",
  "茯苓飲": "BRI",
  "香蘇散": "KOSS",
  "四物湯": "SMT",
  "甘麦大棗湯": "KTT",
  "柴陥湯": "SAK",
  "調胃承気湯": "CJT",
  "四君子湯": "SKST",
  "竜胆瀉肝湯": "RST",
  "芎帰膠艾湯": "KKGT",
  "麻杏薏甘湯": "MKYK",
  "平胃散": "HIS",
  "柴胡清肝湯": "SSET",
  "二陳湯": "NCT",
  "桂枝人参湯": "KNT",
  "抑肝散加陳皮半夏": "YKSCH",
  "大黄甘草湯": "DKZT",
  "神秘湯": "SPT",
  "当帰飲子": "TKI",
  "六味丸": "RJG",
  "二朮湯": "NJT",
  "治打撲一方": "JDI",
  "清肺湯": "SHT",
  "滋陰至宝湯": "JST",
  "滋陰降火湯": "JKT",
  "五虎湯": "GT",
  "柴朴湯": "SBT",
  "大防風湯": "DBFT",
  "黄耆建中湯": "OKT",
  "小建中湯": "SHKT",
  "大建中湯": "DKT",
  "升麻葛根湯": "SMKT",
  "当帰湯": "TOT",
  "酸棗仁湯": "SSNT",
  "辛夷清肺湯": "SSHT",
  "通導散": "TDS",
  "温経湯": "UKT",
  "牛車腎気丸": "GJG",
  "人参養栄湯": "NYT",
  "小柴胡湯加桔梗石膏": "SSKKS",
  "立効散": "RS",
  "清心蓮子飲": "SRI",
  "猪苓湯合四物湯": "CRTST",
  "三黄瀉心湯": "SOST",
  "柴苓湯": "SRT",
  "胃苓湯": "IRT",
  "茯苓飲合半夏厚朴湯": "BRIHK",
  "茵蔯五苓散": "IGRS",
  "苓姜朮甘湯": "RKYJK",
  "苓甘姜味辛夏仁湯": "RKS",
  "黄連湯": "ORT",
  "三物黄芩湯": "SOT",
  "排膿散及湯": "HNST",
  "当帰建中湯": "TKT",
  "川芎茶調散": "SCCS",
  "麻子仁丸": "MNG",
  "麻黄附子細辛湯": "MBST",
  "啓脾湯": "KHT",
  "大承気湯": "DJT",
  "桂枝加芍薬大黄湯": "KSTSD",
  "茵蔯蒿湯": "ICKT",
  "清暑益気湯": "SET",
  "加味帰脾湯": "KKT",
  "桔梗湯": "KYT",
  "紫雲膏": "SK"
};

// ツムラ製品No. → KampoDB Formula ID のマッピング（主要なもの）
export const tsumuraProductNoToKampoDBId = {
  1: "KT",      // 葛根湯
  2: "KTSS",    // 葛根湯加川芎辛夷
  3: "OJT",     // 乙字湯
  5: "ACS",     // 安中散
  6: "JHT",     // 十味敗毒湯
  9: "SST",     // 小柴胡湯
  8: "DST",     // 大柴胡湯
  7: "HJG",     // 八味地黄丸
  19: "SRT",    // 小青竜湯
  10: "SKKT",   // 柴胡桂枝湯
  14: "HST",    // 半夏瀉心湯
  15: "OGT",    // 黄連解毒湯
  17: "GRS",    // 五苓散
  41: "HET",    // 補中益気湯
  24: "KSS",    // 加味逍遙散
  25: "KBG",    // 桂枝茯苓丸
  23: "TSYS",   // 当帰芍薬散
  // 必要に応じて追加
};

/**
 * ツムラの漢方名からKampoDB Formula IDを取得
 * @param {string} tsumuraName - ツムラの漢方名（日本語）
 * @returns {string|null} - KampoDB Formula ID（見つからない場合はnull）
 */
export const getTsumuraToKampoDBId = (tsumuraName) => {
  return tsumuraNameToKampoDBId[tsumuraName] || null;
};

/**
 * ツムラ製品No.からKampoDB Formula IDを取得
 * @param {number} productNo - ツムラ製品No.
 * @returns {string|null} - KampoDB Formula ID（見つからない場合はnull）
 */
export const getProductNoToKampoDBId = (productNo) => {
  return tsumuraProductNoToKampoDBId[productNo] || null;
};

/**
 * 複数のツムラ漢方名からKampoDB Formula IDsの配列を取得
 * @param {Array<string>} tsumuraNames - ツムラの漢方名の配列
 * @returns {Array<string>} - KampoDB Formula IDsの配列（見つかったもののみ）
 */
export const getTsumuraArrayToKampoDBIds = (tsumuraNames) => {
  return tsumuraNames
    .map(name => getTsumuraToKampoDBId(name))
    .filter(id => id !== null);
};

/**
 * 複数のツムラ製品No.からKampoDB Formula IDsの配列を取得
 * @param {Array<number>} productNos - ツムラ製品No.の配列
 * @returns {Array<string>} - KampoDB Formula IDsの配列（見つかったもののみ）
 */
export const getProductNosToKampoDBIds = (productNos) => {
  return productNos
    .map(no => getProductNoToKampoDBId(no))
    .filter(id => id !== null);
};
